import React, { useContext, useState } from "react";
import { get, isEmpty, values } from "lodash";
import * as Yup from "yup";
import {
  Form,
  Button,
  Row,
  Col,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import { Formik, Field } from "formik";
import {
  DatePicker,
  SearchableList,
  FieldDropSide,
  LoaderWrapper,
  SearchDropdownWithAPI,
  Dropside,
  PayrollMultiSelectDropDown,
} from "../../../components";
import {
  OPTIONS_DATA_MAPPER,
  MANAGE_PAYROLL_ROUTES,
  managePayrollFormNames,
  formFields,
  getPathWithParam,
  getFlowBasedFormValues,
  usDateFormat,
  clearFieldValues,
  toOptionValuesFromMapper,
  toMultiSelectValueByFileStatus,
  errors,
} from "../../../utils";
import {
  MANAGE_PAYROLL_FILE_STATUSES,
  manageEligibilityStore,
  managePayrollStore,
  appLayoutStore,
  setManagePageLevelData,
} from "../../../contexts";

import {
  getCompaniesList,
  getFilesBasedOnSearch,
  getFilesCountBasedOnSearch,
  getPlanDetails,
  getPlanList,
} from "../../../services";
import {
  useRouterParams,
  useRequest,
  useDeepEffect,
  useLazyLoadForTable,
} from "../../../abstracts";
import FileStatus from "../../../mocks/fileStatus.json";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import menuPermissions from "../../../mocks/menuPermissions.json";
var today = new Date();
const fileStatus = [
  { label: "Creation in progress", value: 1, checked: false },
  { label: "Upload in progress", value: 2, checked: false },
  { label: "Error Correction Required", value: 3, checked: false },
  { label: "Pending Submission", value: 4, checked: false },
  // { label: "Awaiting Funding", value: 5, checked: false },
  // { label: "Awaiting Trade", value: 6, checked: false },
  { label: "Completed", value: 7, checked: false },
  { label: "Cancelled", value: 8, checked: false },
  { label: "Deleted", value: 9, checked: false },
  //{ label: "Duplicate Records Found", value: 10, checked: false },
  //{ label: "Obsolete", value: 11, checked: false },
  { label: "Error in File Processor", value: 12, checked: false },
  { label: "System Failure", value: 13, checked: false },
  // { label: "Awaiting Fund Confirmation", value: 14, checked: false },
  // { label: "Payroll Funded", value: 15, checked: false },
  // { label: "Funding Failed", value: 16, checked: false },
  //{ label: "Payroll Funding InProgress", value: 17, checked: false },
];
const allOption = { label: "All", value: null };

const PayrollFilterCard = (props) => {
  const {
    setFieldValues,
    setLoading,
    fieldValues,
    pageRefresh,
    refresh,
    setPrevbtn,
    selectButtons,
    clearForm,
    dispatcher,
    setStopInfiniteScroll,
    payrollFilters,
  } = props;
  const initialValue = {
    itemsAlreadyFetched: 0,
    recordsToFetch: 20,
    companyId: 0,
    fileStatus: [],
    planId: 0,
    planName: "All",
    rkPlanNumber: "All",
    companyName: "All",
    searchString: null,
  };
  const [initialValues, setIntialValues] = useState(initialValue);
  const { state, dispatch } = useContext(manageEligibilityStore);
  const userState = useContext(appLayoutStore);
  const { flow } = useRouterParams();
  const formName = managePayrollFormNames.PAYROLL_FILTER;
  const fields = formFields[formName];
  const [planList, setPlanList] = useState([]);
  const [transformedValues, setTransformedValues] = useState(fileStatus);
  const [planLoading, setPlanLoading] = useState(false);
  const [companyList, setCompanyList] = useState([]);

  const generateallOption = [
    {
      ...allOption,
      value: 0,
      label1: planList.length,
      id: 0,
      name: "All",
      rkPlanNumber: "All",
    },
    ...planList.map((plan, index) => ({
      ...plan,
      label: plan.name,
      label1: plan.rkPlanNumber,
      value: plan.id,
    })),
  ];
  const schema = Yup.object().shape({
    fromDate: Yup.date().nullable(),
    toDate: Yup.date()
      .min(
        Yup.ref("fromDate"),
        "PY147 : " + errors.payrollFilterDateOverlap.overlapError
      )
      .nullable(),
    paydateFrom: Yup.date().nullable(),
    paydateTo: Yup.date()
      .min(
        Yup.ref("paydateFrom"),
        "PY148 : " + errors.paydateFilterDateOverlap.overlapError
      )
      .nullable(),
  });

  const subMenuItem =
    menuPermissions[get(userState.state, "userRole")]["payrollSubMenu"]?.[
      "uploadFile"
    ];

  const subTempItem =
    menuPermissions[get(userState.state, "userRole")]["payrollSubMenu"]?.[
      "tempFile"
    ];

  useDeepEffect(() => {
    var updatedstatus = fileStatus.map((item) => {
      if (fieldValues.fileStatus.some((_) => _ == item.value)) {
        return { ...item, checked: true };
      }
      return { ...item, checked: false };
    });
    setTransformedValues(updatedstatus);
    setIntialValues(fieldValues);
  }, [refresh]);

  useDeepEffect(() => {
    setPlanLoading(true);
    getCompaniesList(1)
      .then((response) => {
        setCompanyList(response);
        setPlanLoading(false);
      })
      .catch((error) => {
        setPlanLoading(false);
      });
  }, []);

  useDeepEffect(() => {
    if (!isEmpty(payrollFilters)) {
      getPlanList(fieldValues.companyId).then((response) => {
        setPlanList(response);
      });
    }
  }, [payrollFilters]);

  useDeepEffect(() => {
    if (isEmpty(payrollFilters)) {
      setPlanLoading(true);
      getPlanList(0)
        .then((response) => {
          setPlanList(response);
          setPlanLoading(false);
        })
        .catch((error) => {
          setPlanLoading(false);
        });
    }
  }, []);
  var someDate = new Date();
  const onSubmit = (values, { setFieldError }) => {
    const payload = {
      companyId: values.companyId,
      planId: values.planId,
      fileStatus: values.fileStatus,
      itemsAlreadyFetched: values.itemsAlreadyFetched,
      recordsToFetch: values.recordsToFetch,
      searchString: values.searchString,
      fromDate: values.fromDate,
      toDate: values.toDate,
      paydateFrom: values.paydateFrom,
      paydateTo: values.paydateTo,
      planName: values.planName,
      rkPlanNumber: values.rkPlanNumber,
      companyName: values.companyName,
    };
    setStopInfiniteScroll(false);
    dispatcher(clearForm());
    selectButtons("");
    setPrevbtn(values[fields.fileStatus]);

    setFieldValues(payload);

    pageRefresh();
  };
  return (
    <Formik
      initialValues={{
        ...initialValue,
        ...initialValues,
        fileStatus: initialValues.fileStatus,
        ...getFlowBasedFormValues(get(state, formName, {}), flow),
      }}
      onSubmit={onSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={schema}
    >
      {({
        handleChange,
        setFieldValue,
        setFieldError,
        handleSubmit,
        setValues,
        setErrors,
        values,
        ...rest
      }) => {
        console.log("values", values);
        const onDaySelected = (fieldName, value) => {
          const dateFormete = usDateFormat(value);
          setFieldValue(fieldName, dateFormete);
        };
        const resetFilter = () => {
          setTransformedValues(
            transformedValues.map((item) => {
              return { ...item, checked: false };
            })
          );
          onFileStatusChange([], "b");
          setFieldValue(fields.fileStatus, []);
          setValues({
            ...initialValue,
            fromDate: usDateFormat(moment(today).add(-60, "days")),
            toDate: usDateFormat(new Date()),
          });
          setFieldValues({
            ...initialValue,
            fromDate: usDateFormat(moment(today).add(-60, "days")),
            toDate: usDateFormat(new Date()),
          });
          setPrevbtn([]);
          pageRefresh();
          setErrors({});
        };
        const onFileStatusChange = (value, c) => {
          var payload = {
            ...(c == "a" ? values : initialValues),
            fileStatus: c == "a" ? value : [],
          };
          value != []
            ? setFieldValue(fields.fileStatus, value)
            : setFieldValue(fields.fileStatus, []);
          // pageRefresh();
          setFieldValues({
            ...fieldValues,
            fileStatus: value.length > 0 ? value : [],
            itemsAlreadyFetched: 0,
          });
        };
        const onCompanyChange = (value, plan) => {
          setValues({
            ...clearFieldValues({
              values: values,
              fieldsToExculde: [
                fields.fromDate,
                fields.toDate,
                fields.fileStatus,
              ],
              fieldsToClear: plan
                ? [fields.rkPlanNumber, fields.planId, fields.planName]
                : [],
            }),
            [fields.companyId]:
              value || value === 0 ? parseInt(companyList[value].id) : 0,
            [fields.companyName]:
              value || value === 0 ? companyList[value].name : "All",
            [fields.rkPlanNumber]: plan ? plan.rkPlanNumber : "All",
            [fields.planId]: plan ? plan.id : 0,
            [fields.planName]: plan ? plan.name : "All",
          });
          setPlanLoading(true);
          getPlanList(get(companyList[value], "id", 0)).then((response) => {
            if (response.length == 1) {
              setFieldValue(fields.planId, parseInt(response[0].id));
              setFieldValue(fields.rkPlanNumber, response[0].rkPlanNumber);
              setFieldValue(fields.planName, response[0].name);
              setPlanList(response);
            } else {
              setPlanList(response);
              setFieldValue(fields.planId, 0);
              setFieldValue(fields.rkPlanNumber, "All");
              setFieldValue(fields.planName, "All");
            }
            setPlanLoading(false);
          });
        };
        const onPlanChange = (value) => {
          console.log("value", value);
          if (value || value === 0) {
            var temp = generateallOption.filter((x) => x.id == value);
            setFieldValue(fields.planName, get(temp, "0.name"));
            setFieldValue(fields.planId, parseInt(get(temp, "0.id")));
            setFieldValue(fields.rkPlanNumber, get(temp, "0.rkPlanNumber"));

            const companyOptions = companyList.find(
              (_) => parseInt(_.id) == get(temp, "0.companyId")
            );
            if (value !== 0) {
              setFieldValue(fields.companyName, companyOptions?.name ?? "All");
              setFieldValue(
                fields.companyId,
                parseInt(companyOptions?.id ?? 0)
              );
              getCompaniesList(1)
                .then((response1) => {
                  const requiredCompany = response1.filter((a) =>
                    temp.some((b) => parseInt(a.id) === b.companyId)
                  );
                  if (requiredCompany.length == 1) {
                    setFieldValue(
                      fields.companyName,
                      requiredCompany[0].name ?? "All"
                    );
                    setFieldValue(
                      fields.companyId,
                      parseInt(requiredCompany[0].id)
                    );
                  }
                  setCompanyList(response1);
                  setPlanLoading(false);
                })
                .catch((error) => {
                  setPlanLoading(false);
                });
              setPlanLoading(false);
            }
          } else {
            setFieldValue(fields.planName, "All");
            setFieldValue(fields.planId, 0);
            setFieldValue(fields.rkPlanNumber, "All");
          }
        };

        return (
          <Form
            autoComplete="off"
            className="mt-10"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <div className="d-flex justify-content-space-between">
              <div
                style={{
                  fontWeight: "600px",
                  fontSize: "30px",
                  marginTop: "10px",
                  //marginLeft: "10px",
                }}
              >
                Manage Payroll
              </div>
              <div
                style={{
                  //marginLeft: "800px",
                  marginTop: "7px",
                }}
              >
                {subMenuItem?.includes("C") && subTempItem?.includes("C") ? (
                  <DropdownButton
                    title="New Payroll"
                    style={{ width: "180px" }}
                    align="end"
                    id="dropdown-menu-align-end"
                    className={"request-dropdown"}
                  >
                    <Dropdown.Item>
                      <Link to={MANAGE_PAYROLL_ROUTES.NEW_PAYROLL_UPLOAD}>
                        Standard
                      </Link>
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item>
                      <Link to={MANAGE_PAYROLL_ROUTES.BASIC_INFORMATION}>
                        Temporary
                      </Link>
                    </Dropdown.Item>
                  </DropdownButton>
                ) : subMenuItem?.includes("C") &&
                  !subTempItem?.includes("C") ? (
                  <Dropdown align="end" style={{ width: "120px" }}>
                    <Link
                      to={MANAGE_PAYROLL_ROUTES.NEW_PAYROLL_UPLOAD}
                      className="btn btn-primary request-dropdown"
                    >
                      New Payroll
                    </Link>
                  </Dropdown>
                ) : null}
              </div>
            </div>
            <div className="d-flex align-item-center justify-content-space-between payrollfiltercard">
              <Row>
                <div style={{ marginTop: "16px" }} className="d-flex">
                  <div className="pb-3 pl-3 pr-2">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "6px",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#000000",
                          fontWeight: "500",
                        }}
                      >
                        File Status
                      </div>

                      <div style={{ width: "180px" }}>
                        <Dropside
                          direction="bottom"
                          name={fields.fileStatus}
                          isRequired
                          label="File Status"
                          placeholder={<div className="ft-12">Status</div>}
                          options={fileStatus}
                          isMultiSelect
                          value={toMultiSelectValueByFileStatus(
                            values[fields.fileStatus],
                            fileStatus
                          )}
                          popupContent={
                            <PayrollMultiSelectDropDown
                              hideSelectedOptions="FALSE"
                              width="300px"
                              height="415px"
                              transformedValues={transformedValues}
                              setTransformedValues={setTransformedValues}
                              onSelect={(value) =>
                                onFileStatusChange(value, "a")
                              }
                              name={"FileStatus"}
                              value={values[fields.fileStatus]}
                              showSelectAll={true}
                            />
                          }
                          forPayroll={true}
                          component={FieldDropSide}
                        />
                      </div>
                    </div>
                  </div>
                  <Field
                    size="sm"
                    isRequired
                    label="Company name"
                    name={fields.companyName}
                    value={values[fields.companyName]}
                    direction="bottom"
                    popupContent={
                      <SearchableList
                        label="Select Company"
                        isLoading={planLoading}
                        options={[
                          allOption,
                          ...companyList.map((company, index) => ({
                            label: company.name,
                            value: index,
                          })),
                        ]}
                        onSelect={(value) => onCompanyChange(value, null)}
                        selectedValue={values[fields.companyName]}
                      />
                    }
                    component={FieldDropSide}
                  />
                  <div style={{ marginLeft: "10px" }} className="d-flex">
                    <div
                      style={{ marginRight: "10px" }}
                      className="no-label-transform"
                    >
                      <Field
                        size="sm"
                        isRequired
                        name={fields.planName}
                        value={values[fields.planName]}
                        label={"Plan Name or ID"}
                        placeholder="Select Name or ID"
                        direction="bottom"
                        popupContent={
                          <SearchableList
                            label="Search Keyword"
                            page="managePayroll"
                            options={planList && generateallOption}
                            onSelect={(value) => onPlanChange(value)}
                            selectedValue={values[fields.planName]}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>

                    {/* <div className="bl-0">
                      {planOption === 1 && (
                        <Field
                          size="sm"
                          isRequired
                          name={fields.planName}
                          value={values[fields.planName]}
                          direction="bottom"
                          label=""
                          popupContent={
                            <SearchableList
                              label="Select Plan"
                              options={
                                planList && [
                                  allOption,
                                  ...planList.map((plan, index) => ({
                                    label: plan.name,
                                    value: plan.id,
                                  })),
                                ]
                              }
                              onSelect={(value) => onPlanChange(value)}
                              selectedValue={values[fields.planName]}
                            />
                          }
                          component={FieldDropSide}
                        />
                      )}
                      {planOption === 0 && (
                        <Field
                          size="sm"
                          isRequired
                          name={fields.rkPlanNumber}
                          value={values[fields.rkPlanNumber]}
                          direction="bottom"
                          label=""
                          popupContent={
                            <SearchableList
                              label="Select Plan"
                              options={
                                planList && [
                                  allOption,
                                  ...planList.map((plan, index) => ({
                                    label: plan.rkPlanNumber,
                                    value: plan.id,
                                  })),
                                ]
                              }
                              onSelect={(value) => onPlanChange(value)}
                              selectedValue={values[fields.rkPlanNumber]}
                            />
                          }
                          component={FieldDropSide}
                        />
                      )} */}
                    {/* </div> */}
                  </div>
                  <div className="d-flex br-0">
                    <Field
                      size="sm"
                      isRequired
                      label="Pay date range"
                      name={fields.paydateFrom}
                      value={values[fields.paydateFrom]}
                      isDatePicker
                      placeholder="From date"
                      direction="bottom"
                      onClear={() => onDaySelected(fields.paydateFrom, "")}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.paydateFrom, value)
                          }
                          value={values[fields.paydateFrom]}
                        />
                      }
                      component={FieldDropSide}
                    />

                    <div
                      className="d-flex bl-0"
                      style={{ width: "min-Content" }}
                    >
                      <Field
                        size="sm"
                        label=""
                        text=""
                        name={fields.paydateTo}
                        isRequired
                        placeholder="To date"
                        value={values[fields.paydateTo]}
                        direction="bottom"
                        isDatePicker
                        onClear={() => {
                          onDaySelected(fields.paydateTo, "");
                          onDaySelected(fields.paydateFrom, "");
                          setFieldValues({
                            ...fieldValues,
                            paydateTo: null,
                            paydateFrom: null,
                          });
                        }}
                        onDefaultClearDisplay={values[fields.paydateFrom]}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.paydateTo, value)
                            }
                            value={values[fields.paydateTo]}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>
                  </div>
                  <div
                    style={{ marginLeft: "14px", width: "min-Content" }}
                    className="d-flex"
                  >
                    <div className="d-flex br-0">
                      <Field
                        size="sm"
                        isRequired
                        label="Uploaded Date range"
                        name={fields.fromDate}
                        value={values[fields.fromDate]}
                        isDatePicker
                        placeholder="From date"
                        direction="bottom"
                        onClear={() => onDaySelected(fields.fromDate, "")}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.fromDate, value)
                            }
                            value={values[fields.fromDate]}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>
                    <div className="d-flex bl-0">
                      <Field
                        size="sm"
                        label=""
                        text=""
                        name={fields.toDate}
                        isRequired
                        placeholder="To date"
                        value={values[fields.toDate]}
                        direction="bottom"
                        isDatePicker
                        onClear={() => {
                          onDaySelected(fields.toDate, "");
                          onDaySelected(fields.fromDate, "");
                          setFieldValues({
                            ...fieldValues,
                            toDate: null,
                            fromDate: null,
                          });
                        }}
                        onDefaultClearDisplay={values[fields.fromDate]}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.toDate, value)
                            }
                            value={values[fields.toDate]}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>
                  </div>
                  <Button
                    className="sort-button"
                    style={{
                      marginLeft: "16px",
                      lineHeight: "19px",
                      marginTop: "25px",
                    }}
                    variant="secondary"
                    onClick={() => {
                      resetFilter();
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    className="sort-button"
                    style={{
                      marginLeft: "10px",
                      lineHeight: "19px",
                      marginTop: "25px",
                    }}
                    variant="secondary"
                    type="submit"
                  >
                    Search
                  </Button>
                </div>
                {/* <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "18px",
                    }}
                  >
                    <div
                      style={{
                        //marginBottom: "8px",
                        fontSize: "12px",
                        color: "#000000",
                        fontWeight: "500",
                      }}
                    >
                      Search
                    </div>
                    <div
                      style={{
                        marginTop: "10px",
                      }}
                    >
                      <SearchDropdownWithAPI
                        searchPayload={payrollListPayload}
                        screen="payroll-listing"
                        searchPayloadKey="searchString"
                        labelKey={["fileName", "planName", "companyName"]}
                        placeholder="Search by file name, Company, Plan Name, Plan Id..."
                        handleSelect={handleSearchChange}
                        method={getFilesBasedOnSearch}
                      />
                    </div>
                  </div> */}
              </Row>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default PayrollFilterCard;
